
<form class="PlanRouteForm" @submit.prevent="submit">
  <h2 class="title is-6">{{ isEditMode ? 'Edycja trasy' : 'Trasa' }}</h2>

  <b-message v-if="formError" type="is-danger" size="is-small">
    {{ formError }}
  </b-message>

  <b-field label="Nazwa trasy" :type="fieldType('name')" :message="fieldMessage('name')">
    <b-input v-model="name" required :disabled="isSaving"/>
  </b-field>

  <b-field label="Użytkownik" :type="fieldType('user')" :message="fieldMessage('user')">
    <b-select v-model="user" expanded :disabled="isSaving || isUsersLoading">
      <option :value="null">Bez przypisania</option>
      <option v-for="user in users" :key="user.id" :value="userToIri(user)">
        {{ user.username || user.name || ('Uzytkownik #' + user.id) }}
      </option>
    </b-select>
  </b-field>

  <b-field label="Kolor" :type="fieldType('color')" :message="fieldMessage('color')">
    <div class="PlanRouteForm__colors">
      <button
          v-for="color in colors"
          :key="color.hex"
          type="button"
          class="PlanRouteForm__color"
          :class="{ 'is-selected': routeColor === color.hex }"
          :style="{ backgroundColor: color.hex }"
          :title="color.name"
          @click="routeColor = color.hex"
          :disabled="isSaving"
      >
        <span v-if="routeColor === color.hex" class="mdi">check</span>
      </button>
      <button
          type="button"
          class="button is-small"
          @click="routeColor = null"
          :disabled="isSaving"
      >
        Brak
      </button>
    </div>
  </b-field>

  <button
      type="submit"
      class="button is-success is-fullwidth"
      :class="{ 'is-loading': isSaving }"
      :disabled="isSaving"
  >
    <i class="mdi">{{ isEditMode ? 'save' : 'playlist_add_check' }}</i>
    <span>{{ isEditMode ? 'Zapisz zmiany' : 'Utwórz trasę' }}</span>
  </button>
</form>
